import { render, staticRenderFns } from "./ProvisioningIdentidyInfoContainer.vue?vue&type=template&id=463d84bb"
import script from "./ProvisioningIdentidyInfoContainer.vue?vue&type=script&lang=js"
export * from "./ProvisioningIdentidyInfoContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports